import { slicedToArray as _slicedToArray, defineProperty as _defineProperty, typeof as _typeof, regeneratorRuntime as _regeneratorRuntime } from '../../../../_virtual/_rollupPluginBabelHelpers.mjs';
import { __rest, __awaiter } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { getLocalYYYYMMDD } from '../../utils.mjs';

var INITIAL_STATE = {
  initFetched: false,
  isFetching: false,
  events: {},
  overviewEventOnCalendar: {},
  fetchEvents: function fetchEvents(dateValue, loadRange, query) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  },
  setEvents: function setEvents(events) {},
  addEvent: function addEvent(event) {},
  removeEvent: function removeEvent(eventId) {}
};
var CalendarEventContext = /*#__PURE__*/React__default.createContext(INITIAL_STATE);
var useCalendarEventContext = function useCalendarEventContext() {
  return React__default.useContext(CalendarEventContext);
};
var CalendarEventProvider = function CalendarEventProvider(_ref) {
  var fetchEvents = _ref.fetchEvents,
    children = _ref.children;
  var refIsFetching = React__default.useRef(false);
  var _React$useState = React__default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    initFetched = _React$useState2[0],
    setInitFetched = _React$useState2[1];
  var _React$useState3 = React__default.useState({}),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    events = _React$useState4[0],
    setEventsState = _React$useState4[1];
  var _React$useState5 = React__default.useState({}),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    overviewEventOnCalendar = _React$useState6[0],
    setOverview = _React$useState6[1];
  var setEvents = React__default.useCallback(function (evts) {
    setEventsState(function (prev) {
      return evts.reduce(function (acc, event) {
        acc[event.id] = event;
        return acc;
      }, Object.assign({}, prev));
    });
  }, []);
  var addEvent = React__default.useCallback(function (event) {
    setEventsState(function (prevEvents) {
      return Object.assign(Object.assign({}, prevEvents), _defineProperty({}, event.id, event));
    });
  }, []);
  var removeEvent = React__default.useCallback(function (eventId) {
    setEventsState(function (prevEvents) {
      var _a = prevEvents,
        _b = eventId;
        _a[_b];
        var rest = __rest(_a, [_typeof(_b) === "symbol" ? _b : _b + ""]);
      return rest;
    });
  }, []);
  var fetchHandler = React__default.useCallback(function (dateValue, loadRange, query) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var currentDate, startDate, endDate, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setInitFetched(true);
            if (!refIsFetching.current) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            refIsFetching.current = true;
            currentDate = new Date(dateValue);
            startDate = new Date(dateValue);
            startDate.setDate(currentDate.getDate() - loadRange);
            endDate = new Date(dateValue);
            endDate.setDate(currentDate.getDate() + loadRange);
            _context2.prev = 9;
            _context2.next = 12;
            return fetchEvents({
              startAt: startDate.valueOf(),
              endAt: endDate.valueOf(),
              templateId: query === null || query === void 0 ? void 0 : query.templateId
            });
          case 12:
            response = _context2.sent;
            setEvents(response.data);
            // eslint-disable-next-line no-empty
          case 14:
            _context2.prev = 14;
            refIsFetching.current = false;
            return _context2.finish(14);
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[9,, 14, 17]]);
    }));
  }, [fetchEvents, setEvents]);
  React__default.useEffect(function () {
    if (Boolean(Object.keys(events).length)) {
      setOverview(Object.entries(events).reduce(function (acc, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          eventId = _ref3[0],
          eventDatum = _ref3[1];
        var startDate = new Date(eventDatum.startAt);
        var startAtStr = getLocalYYYYMMDD(startDate);
        if (acc[startAtStr] === undefined) {
          acc[startAtStr] = [];
        }
        acc[startAtStr].push(eventId);
        return acc;
      }, {}));
    }
  }, [events]);
  return jsx(CalendarEventContext.Provider, {
    value: {
      initFetched: initFetched,
      isFetching: refIsFetching.current,
      events: events,
      overviewEventOnCalendar: overviewEventOnCalendar,
      fetchEvents: fetchHandler,
      setEvents: setEvents,
      addEvent: addEvent,
      removeEvent: removeEvent
    },
    children: children
  });
};

export { CalendarEventContext, CalendarEventProvider, useCalendarEventContext };
